// Unauthorized.jsx
import React from 'react';
import {
    Box,
    Typography,
    Button,
    Container,
    Grid,
    Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" sx={{ minHeight: '100vh', py: 8 }}>
            <Grid container spacing={4} justifyContent="center" alignItems="center">
                <Grid item xs={12} md={6} textAlign="center">
                    <Typography variant="h1" color="error.main" sx={{ mb: 2 }}>
                        403
                    </Typography>
                    <Typography variant="h5" color="text.secondary" sx={{ mb: 4 }}>
                        You don\'t have permission to access this page
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/Dashboard')}
                        sx={{ px: 4, py: 1.5 }}
                    >
                        Return to Dashboard
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Unauthorized;
